import { DynamicInputModel, serializable, DynamicFormControlLayout, DynamicInputModelConfig, MATCH_VISIBLE } from '@ng-dynamic-forms/core';
import { PageBuilderItem, PAGE_BUILDER_CODE_COMPONENT } from '../page-builder-components.models';

export enum PAGE_BUILDER_SEPARATOR_STYLE {
	LINE = 'LINE',
	DOTTED = 'DOTTED',
}

export interface PageBuilderHSeparatorModelConfig extends DynamicInputModelConfig {
	separatorStyle: PAGE_BUILDER_SEPARATOR_STYLE;
}

export class PageBuilderHSeparatorModel extends DynamicInputModel {
	@serializable() readonly type: string = 'page_builder_h_separator'; 
	separatorStyle: PAGE_BUILDER_SEPARATOR_STYLE;

	constructor(config: PageBuilderHSeparatorModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
		this.separatorStyle = config.separatorStyle;
	}

	static initModel(_component: PageBuilderItem): PageBuilderHSeparatorModel { 
		const formModel = new PageBuilderHSeparatorModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE,
			separatorStyle: _component.TEXT_STYLE as PAGE_BUILDER_SEPARATOR_STYLE,
		});
		return formModel;
	}

	static getProperties() {
        return {
            CODE: PAGE_BUILDER_CODE_COMPONENT.H_SEPARATOR,
            NAME: 'Separateur Horizontal',
            ICON: 'remove-outline',
            PROPERTIES: [
                { ID: 'TYPE_COMPONENT', CODE: PAGE_BUILDER_CODE_COMPONENT.TEXTBOX, LABEL: 'Type', DEFAULT_VALUE: 'Séparateur Horizontal', IS_READONLY: true },
                { ID: 'INDEX', CODE: PAGE_BUILDER_CODE_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Index' },
                { ID: 'DEFAULT_VALUE', CODE: PAGE_BUILDER_CODE_COMPONENT.TEXTBOX, LABEL: 'Valeur', DEFAULT_VALUE: 'Label' },
                { ID: 'SEPARATOR_STYLE', CODE: PAGE_BUILDER_CODE_COMPONENT.DROPDOWN, LABEL: 'Style', DS_DATAS: [
                    { ID: 'LINE', VALUE: 'Ligne' },
                    { ID: 'DOTTED', VALUE: 'Tirets' },
                ], DS_VALUE_COLUMN_NAME: 'ID', DS_DISPLAY_COLUMN_NAME: 'VALUE', DEFAULT_VALUE: 'LINE' },
            ]
        };
    }
}